import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Shield } from 'lucide-react';
import { CTAButton } from './CTAButton';
const included = ['Acceso inmediato al Máster completo', 'Scripts de Copiar/Pegar listos para usar', 'Guía de Pagos en USD a Colombia', 'Protocolo de Empatía paso a paso', 'Soporte en comunidad privada'];
export function OfferSection() {
  return <section id="pricing" className="w-full bg-gradient-to-br from-emerald-primary via-emerald-secondary to-emerald-primary py-16 md:py-24" data-id="element-118">
      <div className="max-w-5xl mx-auto px-6" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-120">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gold-primary mb-6" data-id="element-121">
            Máster en Micro-Agencia de Setter
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white/10 backdrop-blur-md border-2 border-gold-primary/30 rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-122">
          {/* What's Included */}
          <div className="mb-10" data-id="element-123">
            <h3 className="text-2xl md:text-3xl font-bold text-gold-light mb-6 text-center" data-id="element-124">
              Esto es lo que incluye:
            </h3>
            <ul className="space-y-4" role="list" data-id="element-125">
              {included.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-start gap-4" data-id="element-126">
                  <CheckCircle className="w-6 h-6 text-gold-primary flex-shrink-0 mt-1" aria-hidden="true" data-id="element-127" />
                  <span className="text-lg md:text-xl text-cream-primary" data-id="element-128">
                    {item}
                  </span>
                </motion.li>)}
            </ul>
          </div>

          {/* Price */}
          <motion.div id="price-section" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="text-center mb-8" data-id="element-129">
            <div className="mb-4" data-id="element-130">
              <span className="md:text-7xl font-bold text-gold-primary text-[40px]" data-id="element-131">
                $8 USD
              </span>
            </div>
            <p className="text-lg md:text-xl text-cream-primary max-w-2xl mx-auto" data-id="element-132">
              Menos de lo que cuesta una cena para dos, por una habilidad que te
              dará libertad de por vida.
            </p>
          </motion.div>

          {/* CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="text-center mb-8" data-id="element-133">
            <CTAButton size="large" className="w-full md:w-auto" href="https://orbixdigital.com/cart/51819849089336:1" data-id="element-134">
              Acceder al Máster Ahora
            </CTAButton>
          </motion.div>

          {/* Guarantee */}
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.8
        }} className="flex items-center justify-center gap-3 text-cream-primary" data-id="element-135">
            <Shield className="w-6 h-6 text-gold-primary" aria-hidden="true" data-id="element-136" />
            <span className="text-base md:text-lg" data-id="element-137"></span>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}